import React from "react";
import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
export const CreatePdfCashin = ({ data,escapeRegExp }) => {
  const year = new Date().getFullYear();
  return (
    <Document>
      <Page style={styles.body}>
        <Image style={[styles.img, styles.logoline]} src="./assets/images/detalle-i.png" />
        <View >
          <Text style={[styles.text, styles.sep]} >Fecha del ingreso :
            {format(new Date(data.createdAt), 'yyyy') ===
              year
              ? format(
                new Date(data.createdAt),
                ' dd-MMMM-yyy, HH:mm',
                { awareOfUnicodeTokens: true, locale: es },
              )
              : format(
                new Date(data.createdAt),
                ' dd-MMMM-yyy, HH:mm',
                { awareOfUnicodeTokens: true, locale: es },
              )}
          </Text>

          {data.type === "cashin" && data.counterparty !== undefined && data.counterparty?.name !== undefined ? (
            <Text style={styles.text} >Nombre y Apellido: {data.counterparty?.name}</Text>
          ) : data.type === "cashin" && data._userToId.role === "user" ? (
            <Text style={styles.text} >Nombre y Apellido: {data._userToId.name} {data._userToId.lastname}</Text>
          ) : data.type === "cashin" && (data._userToId.role === "commerce" || data._userToId.role === "branch" || data._userToId.role === "cash") ? (
            <Text style={styles.text} >Nombre de Fantasía: {escapeRegExp(`${data._userToId.fantasyName}`)}</Text>
          ) : null}
          {(data.type === "cashin" && data.counterparty !== undefined && data.counterparty.account_routing?.scheme !== undefined && data.counterparty.account_routing?.address !== undefined) ? (
            <Text style={styles.text} >{data.counterparty.account_routing?.scheme} : {data.counterparty.account_routing?.address}</Text>
          ) : null}
          {data.type === "cashin" && data.counterparty && data.counterparty.bank !== undefined ? (
            <Text style={styles.text} >Banco Emisor: {data.counterparty?.bank}</Text>
          ) : null}

          <Text style={styles.text} >Monto del ingreso :  ${data.amount.toFixed(2)}</Text>

          {data._walletToId.currency === "fiscal_credit" ? (
            <Text style={styles.text}>Monedero: Crédito Fiscal</Text>
          ) : data._walletToId.currency === "peso" ? (
            <Text style={styles.text}>Monedero: Pesos</Text>
          ) : data._walletToId.currency === "peso_tourism" ? (
            <Text style={styles.text}>Monedero: Crédito Turismo</Text>
          ) : data._walletToId.currency === "	peso_activa" ? (
            <Text style={styles.text}>Monedero: Crédito Activa</Text>
          ) : null}

          {data._currencyId.feePercent !== undefined ? (
            <Text style={styles.text} >Porcentaje de la tarifa :  {data._currencyId.feePercent} % </Text>
          ) : null}
          {data.transactionCode !== undefined ? (
            <Text style={styles.text} >N° operación :{data.transactionCode}</Text>
          ) : null}

        </View>

      </Page>
    </Document>
  )
}
const styles = StyleSheet.create({
  logo: {
    width: 70,
    height: 70,
  },
  logoline: {
    width: "105%",
    height: 140,
  },
  body: {
    paddingBottom: 65,
    paddingHorizontal: 35,
    padding: 15,

  },
  contentTitle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 10
  },
  title: {
    fontSize: 35,
    color: "#212121",
  },
  text: {
    marginTop: 30,
    width: "100%",
    backgroundColor: "#f0f0f0",
    paddingHorizontal: 20,
    paddingVertical: 10,
    color: "#212121",

  },
  texta: {
    marginTop: 15,
    width: "100%",
    paddingHorizontal: 20,
    paddingVertical: 10,
    color: "green",
    textAlign: 'center',
    fontSize: 20,
    fontWeight: "bold"
  },
  textb: {
    marginTop: 30,
    width: "100%",
    paddingHorizontal: 20,
    paddingVertical: 10,
    color: "green",
    textAlign: 'center',
    fontSize: 35,
    fontWeight: "bold"
  },
  hr: {
    border: "1px solid green",
    height: 2,
    width: "100%",
    textAlign: 'center',
    marginTop: 15,
  },
  img: {

    position: "absolute",
    top: 0,
    left: 0,
  },
  sep: {
    marginTop: 140,
  }

})